import api from './api'

const baseCoursePath = 'academy/api/AdminCourse/'
const basePackagePath = 'academy/api/AdminPackage/'

const commentDataProvider = {
  postComment(params = {}, path) {
    return api.post(baseCoursePath + path, {
      ...params,
    })
  },
  getComment(id, path) {
    return api.get(baseCoursePath + path + id)
  },
  CountCommentStatus(id, path) {
    return api.get(baseCoursePath + path + id)
  },
  putCommentStatus(params = {}, path) {
    return api.put(baseCoursePath + path, {
      ...params,
    })
  },
  postCommentReply(params = {}, path) {
    return api.post(baseCoursePath + path, {
      ...params,
    })
  },

  postPackageComment(params = {}, path) {
    return api.post(basePackagePath + path, {
      ...params,
    })
  },
  getPackageComment(id, path) {
    return api.get(basePackagePath + path + id)
  },
  CountPackageCommentStatus(id, path) {
    return api.get(basePackagePath + path + id)
  },
  putPackageCommentStatus(params = {}, path) {
    return api.put(basePackagePath + path, {
      ...params,
    })
  },
  postPackageCommentReply(params = {}, path) {
    return api.post(basePackagePath + path, {
      ...params,
    })
  },
}

export default commentDataProvider
